import { Components } from '@mui/material';
import { Theme } from '@mui/material/styles';

import {
  black,
  white,
  grayColors,
  primaryColors,
  secondaryColors,
  statusRed,
  vestaGradient,
  quaternaryColors,
} from './styles/colors';
import { defaultBorder, secondaryBorder } from './styles/mixins';
import { label3 } from './typography';

declare module '@mui/material/Button' {
  interface ButtonPropsVariantOverrides {
    primaryGradient: true;
    primary: true;
    secondary: true;
    negative: true;
    boost: true;
  }
}

const MuiButton: Components<Omit<Theme, 'components'>>['MuiButton'] = {
  styleOverrides: {
    root: {
      ...label3,
      padding: '12px 16px',
      borderRadius: '8px',
    },
  },
  variants: [
    {
      props: { variant: 'primaryGradient' },
      style: {
        background: vestaGradient,
        ...defaultBorder,
        color: grayColors[900],
        '&:hover': {
          background: vestaGradient,
        },
        '&:disabled': {
          background: white['15%'],
          color: white['15%'],
          ...defaultBorder,
        },
      },
    },
    {
      props: { variant: 'primary' },
      style: {
        ...defaultBorder,
        color: secondaryColors[200],
        background: black['85%'],
        '&:hover': {
          background: black['85%'],
          ...secondaryBorder,
        },
        '&:disabled': {
          background: white['15%'],
          color: white['15%'],
          ...defaultBorder,
        },
      },
    },
    {
      props: { variant: 'secondary' },
      style: {
        border: `1px solid ${white['15%']}`,
        '&:hover, &:active': {
          background: primaryColors[100],
          color: primaryColors[900],
        },
        '&:disabled': {
          background: white['15%'],
          color: white['15%'],
          ...defaultBorder,
        },
      },
    },
    {
      props: { variant: 'negative' },
      style: {
        color: statusRed[100],
        border: `1px solid ${statusRed[100]}`,
        background: statusRed[25],
        '&:hover, &:active': {
          background: statusRed[50],
        },
        '&:disabled': {
          background: white['15%'],
          color: white['15%'],
          ...defaultBorder,
        },
      },
    },
    {
      props: { variant: 'boost' },
      style: {
        background: quaternaryColors[500],
        ...defaultBorder,
        color: grayColors[900],
        '&:hover': {
          background: quaternaryColors[500],
        },
        '&:disabled': {
          background: white['15%'],
          color: white['15%'],
          ...defaultBorder,
        },
      },
    },
  ],
};

export default MuiButton;
